module.exports = __webpack_public_path__ + "img/Rustical.1d370283.jpg";